var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73331 15.0334C6.57775 15.0334 6.42798 15.0054 6.28398 14.9494C6.13909 14.8943 6.01109 14.8111 5.89998 14.7L0.33331 9.13337C0.13331 8.93337 0.0386435 8.69426 0.0493102 8.41603C0.0608657 8.1387 0.155532 7.90003 0.33331 7.70003C0.53331 7.50003 0.772421 7.40003 1.05064 7.40003C1.32798 7.40003 1.55553 7.50003 1.73331 7.70003L6.73331 12.7L18.2666 1.1667C18.4444 0.966699 18.6778 0.866699 18.9666 0.866699C19.2555 0.866699 19.4889 0.966699 19.6666 1.1667C19.8666 1.3667 19.9666 1.60537 19.9666 1.8827C19.9666 2.16092 19.8666 2.40003 19.6666 2.60003L7.56664 14.7C7.45553 14.8111 7.32798 14.8943 7.18398 14.9494C7.03909 15.0054 6.88887 15.0334 6.73331 15.0334Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.356802becd5ec8670e2ef9fc9fd12ea6.svg";
export { ForwardRef as ReactComponent };